module.exports = __webpack_public_path__ + "static/media/Onetimeclose.8c2d3673.png";